module.exports = __webpack_public_path__ + "static/media/Formato_Actualizar_documentos_ptm.e5d31eba.xlsx";